export const fr = {
  locale: 'fr',
  messages: {
    lang: 'Langue',
    feed: 'Nouveautés',
    dashboard: 'Panneau de bord',
    profile: 'Profil',
    logout: 'Déconnexion',
    add: 'Ajouter',
    registerhere: "S'enregistrer ici",
    email: 'Email',
    password: 'Mot de passe',
    register: 'Créer un compte',
    loginpage: 'Page de connexion',
    fullname: 'Nom',
    repeatpass: 'Répéter le mot de passe',
    loginTitle: 'Portail de gestion Tikeasy',
    loginSubtitle: 'Identification',
    partnerSpace: 'Espace partenaire ',
  },
};
